import {api} from "./base.api.ts";

export const getFutureClassesForUser2 = async () => {
    const res = await api.get(`booking/getFutureClassesForUser2`);
    return res.data;
};

export const getPendingClassesForUser = async () => {
    const res = await api.get(`booking/getPendingClassesForUser`);
    return res.data;
};

export const getPastClassesForUser = async () => {
    const res = await api.get("booking/getPastClassesForUser");
    return res.data;
};

export const getCancelledClassesForUser = async () => {
    const res = await api.get("booking/getCancelledClassesForUser");
    return res.data;
};

export const calculateBookingPrice = async (data) => {
    const res = await api.post("booking/calculate-booking-price", data);
    return res.data;
};

export const calculateRefundAmount = async (booking) => {
    const res = await api.post("booking/calculate-refund-amount", booking);
    return res.data.data;
};

export const addReview = async (review) => {
    await api.post("booking/add-review", review);
};

export const confirmCancelBooking = async (booking) => {
    await api.post("booking/confirm-cancel-booking", booking);
};

export const getUserReviewById = async ({id, userType}) => {
    const res = await api.get(`booking/get-user-review/${id}/${userType}`);
    return res.data;
};

export const createBooking = async (payload) => {
    const res = await api.post("booking/create-booking", payload);
    return res.data;
};

export const getUserPendingMethods = async (id) => {
    const res = await api.get(`booking/user-has-pending/${id}`);
    return res.data;
};

// Financials detail
export const getFinancialDetailDaily = async ({date}) => {
    const res = await api.get(`booking/financialStats/daily/${date}/${date}`);
    return res.data;
};

export const getFinancialDetailMonthly = async ({year}) => {
    const res = await api.get(`booking/financialStats/monthly/${year}`);
    return res.data;
};

export const getFinancialDetailYearly = async ({year}) => {
    const res = await api.get(`booking/financialStats/yearly/${year}/${year}`);
    return res.data;
};

// Financials transaction
export const getFinancialTransactionDaily = async ({date}) => {
    const res = await api.get(
        `booking/financialStats/daily/${date}/transactions`,
        {
            params: {
                offset: 1,
            },
        }
    );
    return res.data;
};

export const getFinancialTransactionMonthly = async ({year, month}) => {
    const res = await api.get(
        `booking/financialStats/monthly/${year}/${month}/transactions`,
        {
            params: {
                offset: 1,
            },
        }
    );
    return res.data;
};

export const getFinancialTransactionYearly = async ({year}) => {
    const res = await api.get(
        `booking/financialStats/yearly/${year}/transactions`,
        {
            params: {
                offset: 1,
            },
        }
    );
    return res.data;
};

export const getClassRequestForTeacher = async () => {
    const res = await api.get("booking/getClassRequestForTeacher");
    return res.data;
};

export const getFutureClassesForTeacher2 = async () => {
    const res = await api.get("booking/getFutureClassesForTeacher2");
    return res.data;
};
export const getPastClassesForTeacher = async () => {
    const res = await api.get("booking/getPastClassesForTeacher");
    return res.data;
};

export const updateBookingStatus = async (bookingStatus) => {
    await api.post("booking/update-booking-status", bookingStatus);
};

// Reschedule

export const rescheduleBooking = async (data) => {
    const res = await api.post("booking/reschedule-booking", data);
    return res.data;
};

export const getNumberOfRescheduleRequestForTeacher = async () => {
    const res = await api.get("/booking/getNumberOfRescheduleRequestsForTeacher");
    return res.data;
};

export const updateRescheduleStatus = async (data) => {
    const res = await api.post("/booking/updateRescheduleStatus", data);
    return res.data;
};
